<app-page-body [class]="'tw-pt-2'">
  <!-- header -->
  <app-page-header
    custom-header
    [title]="'pages.confirmSmartSmsRequest.title' | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
  >
    <div class="card-toolbar" after-btns>
      <!-- back btn -->
      <a
        type="button"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        mat-ripple
        [matTooltip]="'common.back'|translate"
        (click)="onClose()"
      >
        <i class="mdi mdi-arrow-left mdi-20px p-0"></i>
      </a>
    </div>
  </app-page-header>

  <div class="app-page-content row">
    <fieldset class="tw-h-full secondary-panel">
      <!-- smart sms operators -->
      <app-smart-sms-operators
        (selectedOperator)="selectedOperator=$event"
        [isShowToggle]="false"
        [isDetailMode]="true"
        [isExistsMCI]="isExistsMCI"
        [isExistsIrancell]="isExistsIrancell"
        [isExistsRightel]="isExistsRightel"
      ></app-smart-sms-operators>

      <div class="row">
        <div
          class="xl:tw-w-1/3 tw-w-full tw-my-2"
          [class]="!showSidePanel?'order-1':''"
        >
          <fieldset class="tw-h-full secondary-panel">
            <legend class="tw-flex-center">
              <i class="mdi mdi-earth-box mdi-24px tw-ml-2"></i>
              {{ pageVocabs+"legends.smsPart" | translate }}
            </legend>

            <div *ngIf="!detailModel.isPeriodic">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('title')"
                [value]="detailModel.title"
                label="common.title"
              >
              </form-field>

              <app-periodic-date-time-picker
                class="tw-mt-5"
                [config]="periodicDateTimeConfig"
              >
              </app-periodic-date-time-picker>
            </div>

            <div *ngIf="detailModel.isPeriodic">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('senderNumberId')"
                [value]="detailModel.privateNumberNumber"
                label="common.privateNumber"
              >
              </form-field>
              <app-sms-body
                [numbersType]="'isSmartSendSms'"
                [selectedOrganizationHeader]="selectedItem?.organizationHeader"
                [selectedOrganizationSignature]="selectedItem?.organizationSignature"
                [privateNumbers]="detailModel?.privateNumbers"
                [form]="form"
                valueMaxWidth="2xl:tw-max-w-[230px] xl:tw-max-w-[165px] md:tw-max-w-[500px] sm:tw-max-w-[420px] tw-max-w-[140px]"
                [disabled]="false"
                smsBodyControlName="smsBody"
                senderNumberControlName="senderNumberId"
                [isAddSignature]="false"
                [isShowEditorOptions]="false"
                [isAddHeader]="false"
                [optionValue]="'number'"
                [smsBody]="detailModel?.smsText"
                [isShowSenderNumberId]="false"
                [senderNumberId]="!detailModel?senderNumberId:detailModel?.privateNumberNumber"
                [isSmartSmsTitle]="true"
                [isShowSmsCp]="true"
                [isSmartSend]="true"
                [isSmartDetailMode]="true"
              >
              </app-sms-body>

              <!--#region periodic data-->
              <ng-container *ngIf="detailModel.isPeriodic && dataLoaded">
                <!-- date time filter selector * required item  -->
                <app-periodic-date-time-picker
                  class="tw-mt-5"
                  [config]="periodicDateTimeConfig"
                >
                </app-periodic-date-time-picker>

                <div class="row">
                  <!-- startTime -->
                  <div class="md:tw-w-1/2">
                    <timepicker
                      label="common.startTimeAtDay"
                      [value]="detailModel.startTimeAtDay"
                      (value)="detailModel.startTimeAtDay=$event"
                      [control]="form?.get('startTimeAtDay')"
                      [confirmBtnClass]="'btn' | themeColor"
                    >
                    </timepicker>
                  </div>

                  <!-- endTime -->
                  <div class="md:tw-w-1/2">
                    <timepicker
                      label="common.endTimeAtDay"
                      [value]="detailModel.endTimeAtDay"
                      [control]="form?.get('endTimeAtDay')"
                    >
                    </timepicker>
                  </div>

                  <div class="w-full">
                    <smart-sms-request-periodic-patterns
                      [startDateTime]="detailModel.startDatetime"
                      [endDateTime]="detailModel.endDatetime"
                      [disabled]="!detailModel.startDatetime || !detailModel.endDatetime"
                      [isReadonly]="true"
                      [periodicPattern]="periodicPattern"
                      [selectedDays]="selectedDateTimesForPeriodicPattern"
                    />
                  </div>
                </div>

                <div class="tw-w-full">
                  <app-periodic-type
                    inputClass=""
                    [config]="periodicTypeConfig"
                  >
                  </app-periodic-type>
                </div>

                <div class="tw-w-full">
                  <div class="row">
                    <div class="md:tw-w-1/2">
                      <custom-select-search
                        [label]="fields+'sendCountType'"
                        [items]="
                        $any([
                          { value: 0, name: fields+'percentage' | translate },
                          { value: 1, name: fields+'count' | translate }
                        ])
                      "
                        optionTitle="name"
                        optionValue="value"
                        [removable]="false"
                        [value]="detailModel.isSmartCountAsPercent?0:1"
                        [isDisabled]="true"
                      >
                      </custom-select-search>
                    </div>
                    <div class="md:tw-w-1/2">
                      <form-field
                        *ngIf="detailModel.isSmartCountAsPercent"
                        class="tw-w-full"
                        type="number"
                        [label]="fields+'percentageToSend'"
                        [value]="detailModel.count"
                        [isDisabled]="true"
                      >
                        <span suffix-content matSuffix>
                          <i class="mdi mdi-percent"></i>
                        </span>
                      </form-field>

                      <form-field
                        *ngIf="detailModel.isSmartCountAsPercent==false"
                        class="tw-w-full"
                        type="number"
                        [label]="fields+'countToSend'"
                        [value]="detailModel.count"
                        [isDisabled]="true"
                      >
                        <span suffix-content matSuffix>
                          <i class="mdi mdi-account-multiple"></i>
                        </span>
                      </form-field>
                    </div>
                  </div>
                </div>

                <!-- maxSendCount -->
                <div class="tw-w-full">
                  <div class="row">
                    <div class="md:tw-w-1/2">
                      <form-field
                        type="tel"
                        [hasNumberSeparator]="true"
                        [value]="detailModel.maxSendCount"
                        [control]="form?.get('maxSendCount')"
                        [label]="fields + 'maxSendCount' | translate"
                      >
                      </form-field>
                    </div>

                    <!-- maxDailySendCount -->
                    <div class="md:tw-w-1/2">
                      <form-field
                        [control]="form?.get('maxDailySendCount')"
                        type="tel"
                        [hasNumberSeparator]="true"
                        [value]="detailModel.maxDailySendCount"
                        [label]="fields + 'maxDailySendCount' | translate"
                      >
                      </form-field>
                    </div>
                    <!-- socialMediaFileTitle -->
                    <div class="md:tw-w-1/2">
                      <form-field
                        type="tel"
                        [hasNumberSeparator]="true"
                        [control]="form?.get('socialMediaFileTitle')"
                        [value]="detailModel.socialMediaFileTitle"
                        [label]="fields + 'socialMediaFileTitle' | translate"
                      >
                      </form-field>
                    </div>
                    <!-- socialMediaApplicationName -->
                    <div class="md:tw-w-1/2">
                      <form-field
                        type="tel"
                        [hasNumberSeparator]="true"
                        [control]="form?.get('socialMediaApplicationName')"
                        [value]="detailModel.socialMediaApplicationName"
                        [label]="fields + 'socialMediaApplicationName' | translate"
                      >
                      </form-field>
                    </div>
                  </div>

                  <div class="md:tw-w-full">
                    <list-group-item
                      [label]="'common.continueSendIfAnyOperatorHaveError'|translate"
                      [isShowValue]="false"
                    >
                      <div
                        class="badge badge-light border tw-text-gray-800 tw-text-[13px] dir-ltr"
                        content
                      >
                        <td-value
                          type="boolean"
                          [value]="detailModel.continueSendIfAnyOperatorHaveError"
                        ></td-value>
                      </div>
                    </list-group-item>
                  </div>
                </div>

                <!-- description for user -->
                <div class="tw-text-lg dark:tw-text-gray-300">
                  <span>
                    {{ pageVocabs + "legends.yourCampaignFrom" | translate }}
                  </span>
                  <b class="text-teal"
                    >{{detailModel.startDatetime |
                    dateTimeConvertor:appLang|checkValue}}</b
                  >
                  <span>
                    {{ pageVocabs + "legends.untilDate" | translate }}
                  </span>
                  <b class="text-teal"
                    >{{detailModel.endDatetime|dateTimeConvertor:appLang|checkValue}}</b
                  >
                  <span>
                    {{ pageVocabs + "legends.every" | translate }}
                    <b class="text-teal"
                      >{{detailModel.periodValue}} {{ pageVocabs +
                      "legends.period" | translate }}
                    </b>
                    {{ pageVocabs + "legends.runAnd" | translate }}
                  </span>
                  <ng-container *ngIf="detailModel.isSmartCountAsPercent">
                    <b class="text-teal"> {{detailModel.count}}% </b>
                  </ng-container>
                  <ng-container *ngIf="!detailModel.isSmartCountAsPercent">
                    <b class="text-teal">
                      {{detailModel.count}} {{ pageVocabs + "legends.person" |
                      translate }}
                    </b>
                  </ng-container>
                  <span>
                    {{ pageVocabs + "legends.ofTheTargetNumbersWillReceiveSMS" |
                    translate }}.
                  </span>
                </div>
              </ng-container>
              <!--#endregio-->
            </div>

            <!--grayListExpireHour-->
            <div
              class="tw-w-full tw-mt-3"
              *ngIf="detailModel?.grayListExpireHour"
            >
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('grayListExpireHour')"
                [value]="detailModel?.grayListExpireHour"
                [label]="'pages.createSmartSmsRequest.timingOfRepetitions' | translate"
              >
              </form-field>
            </div>

            <!--grayListExpireHour-->
            <div
              class="tw-w-full tw-mt-3"
              *ngIf="detailModel?.smartSmsCampaignTitle"
            >
              <form-field
                [control]="form?.get('campaignId')"
                [value]="detailModel?.smartSmsCampaignTitle"
                label="common.grayList"
              >
              </form-field>
            </div>

            <!--smartSmsClubTitle-->
            <div
              class="tw-w-full tw-mt-3"
              *ngIf="detailModel?.smartSmsClubTitle"
            >
              <form-field
                [control]="form?.get('smartSmsClubTitle')"
                [value]="detailModel?.smartSmsClubTitle"
                label="common.smartSmsClubTitle"
              >
              </form-field>
            </div>

            <!--smartSmsClubOperationTypeTitle-->
            <div
              class="tw-w-full tw-mt-3"
              *ngIf="detailModel?.smartSmsClubOperationTypeTitle"
            >
              <form-field
                [control]="form?.get('smartSmsClubOperationTypeTitle')"
                [value]="detailModel?.smartSmsClubOperationTypeTitle"
                label="pages.createSmartSmsRequest.operationType"
              >
              </form-field>
            </div>

            <app-view-filters #filterViewer></app-view-filters>
            <div
              class="tw-pl-[10px] ltr:tw-pr-[10px] tw-pr-[10px] ltr:tw-pl-[10px] tw-min-h-[100px]"
              *ngIf="data?.numberPrefix"
            >
              <list-group-item
                [label]="'common.mobilePrefix'|translate"
                [value]="data?.numberPrefix"
                marginClass="tw-my-0"
              >
              </list-group-item>
            </div>
          </fieldset>
        </div>

        <div
          class="tw-w-full tw-my-2"
          [class]="!showSidePanel?'xl:tw-w-full':'xl:tw-w-2/3'"
        >
          <fieldset class="tw-h-full secondary-panel">
            <legend class="tw-flex-center">
              <i class="mdi mdi-earth-box mdi-24px tw-ml-2"></i>
              {{ pageVocabs+"legends.publicMap" | translate }}
            </legend>

            <div class="row">
              <div
                class="tw-w-full"
                [ngClass]="{'tw-relative disable-mapboxgl-canvas': !isShowMap}"
              >
                @if(!isShowMap){
                <div
                  class="tw-absolute tw-w-full tw-h-full tw-bg-slate-50 dark:tw-bg-slate-800 tw-opacity-40 tw-z-[1] tw-right-0 tw-flex-center"
                ></div>
                <span
                  class="tw-absolute tw-text-gray-500 dark:tw-text-white tw-font-extrabold tw-text-xl text-color tw-top-2/4 tw-left-0 tw-right-0 tw-text-center tw-z-[1]"
                  >{{'messages.disableMapInSmartSmsDetail'|translate}}</span
                >
                }
                <app-smart-send-confirmation-map-component
                  #Map
                  (OnLoad)="onMapLoad()"
                  [selectedOperator]="selectedOperator"
                  [isUpdateMode]="false"
                  [ShowPanel]="true"
                  [showDetail]="detailModel.isPeriodic==false"
                  [isDetailMode]="true"
                  [isShowRecipients]="isShowMap"
                  (expandMap)="isShowSidePanel($event)"
                  (OnNextStepClick)="onSubmit()"
                ></app-smart-send-confirmation-map-component>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </fieldset>
  </div>
</app-page-body>
